export default __webpack_public_path__ + "static/hero-image-2159961194ba0bf9143bff980de85d1f.svg";